<template>
  <div id="login_main">
    <div class="login_box">
      <div class="login_warp">
        <div class="form" id="loginForm">
          <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" auto-complete="on"
            label-position="left">
            <div class="title-container">
              <h3 class="title">用户登录</h3>
            </div>
            <el-form-item prop="username">
              <div class="flex align_center input_row">
                <img class="icon_input" src="../../assets/image/loginUserIcon.png" alt="" srcset="">
                <el-input class="el-input" ref="username" v-model="loginForm.username" placeholder="请输入帐号" name="username"
                  type="text" tabindex="1" auto-complete="on" />
              </div>
            </el-form-item>
            <el-form-item prop="pass">
              <div class="flex align_center input_row">
                <img class="icon_input" src="../../assets/image/loginPwdIcon.png" alt="" srcset="">
                <el-input :key="passwordType" ref="password" v-model="loginForm.password" :type="passwordType"
                  placeholder="请输入密码" name="password" tabindex="2" auto-complete="on" @keyup.enter.native="handleLogin" />
              </div>
            </el-form-item>
            <el-button :loading="loading" class="login_btn" style="width:100%;margin-bottom:30px;"
              @click.native.prevent="sumbitFun">登录
            </el-button>
            <div class="tips flex justify-content-center" v-if="isOpenRegister + '' === 'true'">
              <span>暂无账号</span>
              <el-link type="danger" @click="registerTo">立即注册</el-link>
            </div>
          </el-form>
        </div>
      </div>
    </div>
    <div class="footer">
      <p>联系我们：0516-886523556</p>
      <p>主办单位：地铁集团 备案号：苏ICP备05002356号-2</p>
    </div>
  </div>
</template>
  
<script>
import { loginDo, commonParam } from "@/api/user";
import { mapActions } from "vuex";
import { isPhoneno } from '@/utils/validate'
export default {
  name: 'Login',
  data() {
    const validPhone = (rule, value, callback) => {
      if (!isPhoneno(value)) {
        callback(new Error('手机号格式有误'))
      } else {
        callback()
      }
    }
    return {
      isOpenRegister: false,
      loading: false,
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [{ required: true, trigger: 'blur', validator: validPhone }],
        password: [{ required: true, trigger: 'blur', message: '密码不可为空' }],
      },
      passwordType: 'password',
      confirmPasswordType: 'password',
    };
  },
  computed: {},
  mounted() {
    console.log("============")
    commonParam().then(res => {
      this.isOpenRegister = res.data.isOpenRegister;
    })
  },
  methods: {
    ...mapActions(["SetToken", "setUser"]),
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    forgotTo() {
      this.$router.push('/forgot');
    },
    registerTo() {
      this.$router.push('/register');
    },
    sumbitFun() {
      loginDo(this.loginForm).then((res) => {
        if (res.code + '' === '200') {
          this.setUser(res.data)
          this.SetToken(res.data.token)
          this.$message.success('登录成功');
          this.$router.push("/home");
          // this.$router.push("/identity");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/login';
</style>